import axios from "axios";
import { getApiBaseUrl } from "../../config/env";

export const api = axios.create({
  baseURL: getApiBaseUrl(),
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});


function attachAuth(config) {
  try {
    const raw = localStorage.getItem("user");
    if (!raw) return config;
    const parsed = JSON.parse(raw);
    const token = parsed?.token || parsed?.user?.token;
    if (token && !config.headers?.Authorization) {
      config.headers = { ...config.headers, Authorization: `Bearer ${token}` };
    }
  } catch {
    // ignore corrupt storage
  }
  return config;
}

api.interceptors.request.use(attachAuth);